import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=63c86b88"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports